import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './Providers/Routes/AuthGuard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./Pages/Auth/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'tabs',
        pathMatch: 'full'
      },
      {
        path: 'tabs',
        loadChildren: () => import('./Pages/Core/tabs/tabs.module').then(m => m.TabsPageModule),
      },
      {
        path: 'notifications',
        loadChildren: () => import('./Pages/Notifications/notifications-list/notifications-list.module').then(m => m.NotificationsListPageModule)
      },
      {
        path: 'modules-items',
        loadChildren: () => import('./Pages/Modules/modules-items/modules-items.module').then(m => m.ModulesItemsPageModule)
      },
      {
        path: 'modules-store',
        loadChildren: () => import('./Pages/Modules/modules-store/modules-store.module').then(m => m.ModulesStorePageModule)
      },
      {
        path: 'edit-password',
        loadChildren: () => import('./Pages/Configuration/edit-password/edit-password.module').then(m => m.EditPasswordPageModule)
      },
      {
        path: 'edit-profile',
        loadChildren: () => import('./Pages/Configuration/edit-profile/edit-profile.module').then(m => m.EditProfilePageModule)
      },
      {
        path: 'edit-pin',
        loadChildren: () => import('./Pages/Configuration/edit-pin/edit-pin.module').then(m => m.EditPinPageModule)
      },
      {
        path: 'notifications-config',
        loadChildren: () => import('./Pages/Configuration/notifications-config/notifications-config.module').then(m => m.NotificationsConfigPageModule)
      },
      {
        path: 'devices-store',
        loadChildren: () => import('./Pages/Configuration/devices/devices-store/devices-store.module').then(m => m.DevicesStorePageModule)
      },
      {
        path: 'users-store',
        loadChildren: () => import('./Pages/Configuration/users/users-store/users-store.module').then(m => m.UsersStorePageModule)
      },
      {
        path: 'users/:id',
        loadChildren: () => import('./Pages/Configuration/users/user-detail/user-detail.module').then(m => m.UserDetailPageModule)
      },
      {
        path: 'file-store',
        loadChildren: () => import('./Pages/Rrhh/Folders/file-store/file-store.module').then(m => m.FileStorePageModule)
      },
      {
        path: 'file-info',
        loadChildren: () => import('./Pages/Rrhh/Folders/file-info/file-info.module').then(m => m.FileInfoPageModule)
      },
      {
        path: 'gallery',
        loadChildren: () => import('./Pages/Shared/gallery/gallery.module').then(m => m.GalleryPageModule)
      },
      {
        path: 'holiday-store',
        loadChildren: () => import('./Pages/Rrhh/Holidays/holidays-store/holidays-store.module').then(m => m.HolidaysStorePageModule)
      },
      {
        path: 'requests-store',
        loadChildren: () => import('./Pages/Rrhh/Requests/requests-store/requests-store.module').then(m => m.RequestsStorePageModule)
      },
      {
        path: 'clock-in-store',
        loadChildren: () => import('./Pages/Rrhh/Clock-in/clock-in-store/clock-in-store.module').then(m => m.ClockInStorePageModule)
      },
      {
        path: 'schedule-store',
        loadChildren: () => import('./Pages/Rrhh/Schedules/schedule-store/schedule-store.module').then(m => m.ScheduleStorePageModule)
      },
      {
        path: 'product/:id',
        loadChildren: () => import('./Pages/Purchases/Products/product-detail/product-detail.module').then(m => m.ProductDetailPageModule)
      },
      {
        path: 'product-store',
        loadChildren: () => import('./Pages/Purchases/Products/product-store/product-store.module').then(m => m.ProductStorePageModule)
      },
      {
        path: 'product-provider-store',
        loadChildren: () => import('./Pages/Purchases/Products/product-provider-store/product-provider-store.module').then(m => m.ProductProviderStorePageModule)
      },
      {
        path: 'provider/:id',
        loadChildren: () => import('./Pages/Purchases/Providers/provider-detail/provider-detail.module').then(m => m.ProviderDetailPageModule)
      },
      {
        path: 'provider-store',
        loadChildren: () => import('./Pages/Purchases/Providers/provider-store/provider-store.module').then(m => m.ProviderStorePageModule)
      },
      {
        path: 'provider-contact-store',
        loadChildren: () => import('./Pages/Purchases/Providers/provider-contact-store/provider-contact-store.module').then(m => m.ProviderContactStorePageModule)
      },
      {
        path: 'provider-product-store',
        loadChildren: () => import('./Pages/Purchases/Providers/provider-product-store/provider-product-store.module').then(m => m.ProviderProductStorePageModule)
      },
      {
        path: 'order/:id',
        loadChildren: () => import('./Pages/Purchases/Orders/order-detail/order-detail.module').then(m => m.OrderDetailPageModule)
      },
      {
        path: 'order-store',
        loadChildren: () => import('./Pages/Purchases/Orders/order-store/order-store.module').then(m => m.OrderStorePageModule)
      },
      {
        path: 'delivery-note/:id',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/delivery-note-detail/delivery-note-detail.module').then(m => m.DeliveryNoteDetailPageModule)
      },
      {
        path: 'delivery-note-store',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/delivery-note-store/delivery-note-store.module').then(m => m.DeliveryNoteStorePageModule)
      },
      {
        path: 'cash-closing/:id',
        loadChildren: () => import('./Pages/Finances/Cash-closing/cash-closing-detail/cash-closing-detail.module').then(m => m.CashClosingDetailPageModule)
      },
      {
        path: 'cash-closing-store',
        loadChildren: () => import('./Pages/Finances/Cash-closing/cash-closing-store/cash-closing-store.module').then(m => m.CashClosingStorePageModule)
      },
      {
        path: 'ebitda-detail',
        loadChildren: () => import('./Pages/Finances/Ebitda/ebitda-detail/ebitda-detail.module').then(m => m.EbitdaDetailPageModule)
      },
      {
        path: 'ebitda-report-options',
        loadChildren: () => import('./Pages/Finances/Ebitda/ebitda-report-options/ebitda-report-options.module').then(m => m.EbitdaReportOptionsPageModule)
      },
      {
        path: 'personal-payments-store',
        loadChildren: () => import('./Pages/Finances/Cash-closing/personal-payments-store/personal-payments-store.module').then(m => m.PersonalPaymentsStorePageModule)
      },
      {
        path: 'income-store',
        loadChildren: () => import('./Pages/Finances/Cash-closing/income-store/income-store.module').then(m => m.IncomeStorePageModule)
      },
      {
        path: 'purchase-payments-store',
        loadChildren: () => import('./Pages/Finances/Cash-closing/purchase-payments-store/purchase-payments-store.module').then(m => m.PurchasePaymentsStorePageModule)
      },
      {
        path: 'general-expenses-store',
        loadChildren: () => import('./Pages/Finances/Expenses/general-expenses-store/general-expenses-store.module').then(m => m.GeneralExpensesStorePageModule)
      },
      {
        path: 'personal-expenses-store',
        loadChildren: () => import('./Pages/Finances/Expenses/personal-expenses-store/personal-expenses-store.module').then(m => m.PersonalExpensesStorePageModule)
      },
      {
        path: 'expenses-options',
        loadChildren: () => import('./Pages/Finances/Expenses/expenses-options/expenses-options.module').then(m => m.ExpensesOptionsPageModule)
      },
      {
        path: 'expense-detail',
        loadChildren: () => import('./Pages/Finances/Expenses/expense-detail/expense-detail.module').then(m => m.ExpenseDetailPageModule)
      },
      {
        path: 'elaboration/:id',
        loadChildren: () => import('./Pages/YuChef/Elaborations/elaboration-detail/elaboration-detail.module').then(m => m.ElaborationDetailPageModule)
      },
      {
        path: 'elaboration-store',
        loadChildren: () => import('./Pages/YuChef/Elaborations/elaboration-store/elaboration-store.module').then(m => m.ElaborationStorePageModule)
      },
      {
        path: 'elaboration-step-store',
        loadChildren: () => import('./Pages/YuChef/Elaborations/elaboration-step-store/elaboration-step-store.module').then(m => m.ElaborationStepStorePageModule)
      },
      {
        path: 'recipe-costing/:id',
        loadChildren: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-detail/recipe-costing-detail.module').then(m => m.RecipeCostingDetailPageModule)
      },
      {
        path: 'recipe-costing-store',
        loadChildren: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-store/recipe-costing-store.module').then(m => m.RecipeCostingStorePageModule)
      },
      {
        path: 'recipe-costing-ingredient-store',
        loadChildren: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-ingredient-store/recipe-costing-ingredient-store.module').then(m => m.RecipeCostingIngredientStorePageModule)
      },
      {
        path: 'recipe-costing-step-store',
        loadChildren: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-step-store/recipe-costing-step-store.module').then(m => m.RecipeCostingStepStorePageModule)
      },
      {
        path: 'recipe/:id',
        loadChildren: () => import('./Pages/YuChef/Recipes/recipes-detail/recipes-detail.module').then(m => m.RecipesDetailPageModule)
      },
      {
        path: 'recipe-store',
        loadChildren: () => import('./Pages/YuChef/Recipes/recipe-store/recipe-store.module').then(m => m.RecipeStorePageModule)
      },
      {
        path: 'recipe-step-store',
        loadChildren: () => import('./Pages/YuChef/Recipes/recipe-step-store/recipe-step-store.module').then(m => m.RecipeStepStorePageModule)
      },
      {
        path: 'recipe-ingredient-store',
        loadChildren: () => import('./Pages/YuChef/Recipes/recipe-ingredient-store/recipe-ingredient-store.module').then(m => m.RecipeIngredientStorePageModule)
      },
      {
        path: 'recipe-result-store',
        loadChildren: () => import('./Pages/YuChef/Recipes/recipe-result-store/recipe-result-store.module').then(m => m.RecipeResultStorePageModule)
      },
      {
        path: 'labeled-store',
        loadChildren: () => import('./Pages/YuChef/Labeled/labeled-store/labeled-store.module').then(m => m.LabeledStorePageModule)
      },
      {
        path: 'labeled-history',
        loadChildren: () => import('./Pages/YuChef/Labeled/labeled-history/labeled-history.module').then(m => m.LabeledHistoryPageModule)
      },
      {
        path: 'labeled-add-info',
        loadChildren: () => import('./Pages/YuChef/Labeled/labeled-add-info/labeled-add-info.module').then(m => m.LabeledAddInfoPageModule)
      },
      {
        path: 'mise-en-place-options',
        loadChildren: () => import('./Pages/YuChef/Mise-en-place/mise-en-place-options/mise-en-place-options.module').then(m => m.MiseEnPlaceOptionsPageModule)
      },
      {
        path: 'production-elaboration-store',
        loadChildren: () => import('./Pages/YuChef/Mise-en-place/production-elaboration-store/production-elaboration-store.module').then(m => m.ProductionElaborationStorePageModule)
      },
      {
        path: 'production-recipe-store',
        loadChildren: () => import('./Pages/YuChef/Mise-en-place/production-recipe-store/production-recipe-store.module').then(m => m.ProductionRecipeStorePageModule)
      },
      {
        path: 'min-max-store',
        loadChildren: () => import('./Pages/Warehouse/Stocks/min-max-store/min-max-store.module').then(m => m.MinMaxStorePageModule)
      },
      {
        path: 'task/:id',
        loadChildren: () => import('./Pages/Tasks/General/task-detail/task-detail.module').then(m => m.TaskDetailPageModule)
      },
      {
        path: 'task-store',
        loadChildren: () => import('./Pages/Tasks/General/task-store/task-store.module').then(m => m.TaskStorePageModule)
      },
      {
        path: 'task-options',
        loadChildren: () => import('./Pages/Tasks/General/task-options/task-options.module').then(m => m.TaskOptionsPageModule)
      },
      {
        path: 'image-reviewer',
        loadChildren: () => import('./Pages/Tasks/Image-reviewer/image-reviewer-list/image-reviewer-list.module').then(m => m.ImageReviewerListPageModule)
      },
      {
        path: 'image-reviewer-options',
        loadChildren: () => import('./Pages/Tasks/Image-reviewer/image-reviewer-options/image-reviewer-options.module').then(m => m.ImageReviewerOptionsPageModule)
      },
      {
        path: 'model-store',
        loadChildren: () => import('./Pages/Tasks/Checklists/Models/model-store/model-store.module').then(m => m.ModelStorePageModule)
      },
      {
        path: 'model/:id',
        loadChildren: () => import('./Pages/Tasks/Checklists/Models/model-detail/model-detail.module').then(m => m.ModelDetailPageModule)
      },
      {
        path: 'field-store',
        loadChildren: () => import('./Pages/Tasks/Checklists/Models/field-store/field-store.module').then(m => m.FieldStorePageModule)
      },
      {
        path: 'schedules-checklist-store',
        loadChildren: () => import('./Pages/Tasks/Checklists/Schedules/schedules-checklist-store/schedules-checklist-store.module').then(m => m.SchedulesChecklistStorePageModule)
      },
      {
        path: 'schedules-appcc-store',
        loadChildren: () => import('./Pages/Tasks/Appccs/Schedules/schedules-appcc-store/schedules-appcc-store.module').then(m => m.SchedulesAppccStorePageModule)
      },
      {
        path: 'machine-appcc-store',
        loadChildren: () => import('./Pages/Tasks/Appccs/Checkpoints/machine-appcc-store/machine-appcc-store.module').then(m => m.MachineAppccStorePageModule)
      },
      {
        path: 'product-appcc-store',
        loadChildren: () => import('./Pages/Tasks/Appccs/Checkpoints/product-appcc-store/product-appcc-store.module').then(m => m.ProductAppccStorePageModule)
      },
      {
        path: 'provider-appcc-store',
        loadChildren: () => import('./Pages/Tasks/Appccs/Checkpoints/provider-appcc-store/provider-appcc-store.module').then(m => m.ProviderAppccStorePageModule)
      },
      {
        path: 'machine/:id',
        loadChildren: () => import('./Pages/Tasks/Appccs/Checkpoints/machine-detail/machine-detail.module').then(m => m.MachineDetailPageModule)
      },
      {
        path: 'wastages-store',
        loadChildren: () => import('./Pages/Warehouse/Wastages/wastages-store/wastages-store.module').then(m => m.WastagesStorePageModule)
      },
      {
        path: 'operation',
        children: [
          {
            path: 'reload/:id',
            loadChildren: () => import('./Pages/Warehouse/Operations/operation-reload/operation-reload.module').then(m => m.OperationReloadPageModule)
          },
          {
            path: 'inventory/:id',
            loadChildren: () => import('./Pages/Warehouse/Operations/operation-inventory/operation-inventory.module').then(m => m.OperationInventoryPageModule)
          },
          {
            path: 'revision/:id',
            loadChildren: () => import('./Pages/Warehouse/Operations/operation-revision/operation-revision.module').then(m => m.OperationRevisionPageModule)
          }
        ],
      },
      {
        path: 'operation-inventory-options',
        loadChildren: () => import('./Pages/Warehouse/Operations/operation-inventory-options/operation-inventory-options.module').then(m => m.OperationInventoryOptionsPageModule)
      },
      {
        path: 'product-providers-formats',
        loadChildren: () => import('./Pages/Shared/product-providers-formats/product-providers-formats.module').then(m => m.ProductProvidersFormatsPageModule)
      },
      {
        path: 'transfers-options',
        loadChildren: () => import('./Pages/Warehouse/Transfers/transfers-options/transfers-options.module').then(m => m.TransfersOptionsPageModule)
      },
      {
        path: 'transfer-store',
        loadChildren: () => import('./Pages/Warehouse/Transfers/transfer-store/transfer-store.module').then(m => m.TransferStorePageModule)
      },
      {
        path: 'transfer/:id',
        loadChildren: () => import('./Pages/Warehouse/Transfers/transfer-detail/transfer-detail.module').then(m => m.TransferDetailPageModule)
      },
      {
        path: 'transfer-product-store',
        loadChildren: () => import('./Pages/Warehouse/Transfers/transfer-product-store/transfer-product-store.module').then(m => m.TransferProductStorePageModule)
      },
      {
        path: 'stocks-product-store',
        loadChildren: () => import('./Pages/Warehouse/Stocks/stocks-product-store/stocks-product-store.module').then(m => m.StocksProductStorePageModule)
      },
      {
        path: 'transfer-stock',
        loadChildren: () => import('./Pages/Warehouse/Transfers/transfer-stock/transfer-stock.module').then(m => m.TransferStockPageModule)
      },
      {
        path: 'inventory-stock',
        loadChildren: () => import('./Pages/Warehouse/Inventory/inventory-stock/inventory-stock.module').then(m => m.InventoryStockPageModule)
      },
      {
        path: 'stock-products-revision',
        loadChildren: () => import('./Pages/Warehouse/Stocks/stock-products-revision/stock-products-revision.module').then(m => m.StockProductsRevisionPageModule)
      },
      {
        path: 'send-order-email',
        loadChildren: () => import('./Pages/Purchases/Orders/send-order-email/send-order-email.module').then(m => m.SendOrderEmailPageModule)
      },
      {
        path: 'add-previous-order',
        loadChildren: () => import('./Pages/Purchases/Orders/add-previous-order/add-previous-order.module').then(m => m.AddPreviousOrderPageModule)
      },
      {
        path: 'add-products-order',
        loadChildren: () => import('./Pages/Purchases/Orders/add-products-order/add-products-order.module').then(m => m.AddProductsOrderPageModule)
      },
      {
        path: 'select-pendents-products',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/select-pendents-products/select-pendents-products.module').then(m => m.SelectPendentsProductsPageModule)
      },
      {
        path: 'add-products-delivery-note',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/add-products-delivery-note/add-products-delivery-note.module').then(m => m.AddProductsDeliveryNotePageModule)
      },
      {
        path: 'sign-delivery-note',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/sign-delivery-note/sign-delivery-note.module').then(m => m.SignDeliveryNotePageModule)
      },
      {
        path: 'edit-product',
        loadChildren: () => import('./Pages/Purchases/Delivery-notes/edit-product/edit-product.module').then(m => m.EditProductPageModule)
      },
      {
        path: 'multisession-list',
        loadChildren: () => import('./Pages/Multisession/multisession-list/multisession-list.module').then(m => m.MultisessionListPageModule)
      },
      {
        path: 'keyboard-modal',
        loadChildren: () => import('./Pages/Shared/keyboard-modal/keyboard-modal.module').then(m => m.KeyboardModalPageModule)
      },
      {
        path: 'purchases-reports-options',
        loadChildren: () => import('./Pages/Reports/Purchases/Shared/purchases-reports-options/purchases-reports-options.module').then(m => m.PurchasesReportsOptionsPageModule)
      },
      {
        path: 'tasks-reports-options',
        loadChildren: () => import('./Pages/Reports/Tasks/Shared/tasks-reports-options/tasks-reports-options.module').then(m => m.TasksReportsOptionsPageModule)
      },
      {
        path: 'ranking-list',
        loadChildren: () => import('./Pages/Reports/Tasks/Shared/ranking-list/ranking-list.module').then(m => m.RankingListPageModule)
      },
      {
        path: 'task-detail-report',
        loadChildren: () => import('./Pages/Reports/Tasks/Shared/task-detail-report/task-detail-report.module').then(m => m.TaskDetailReportPageModule)
      },
      {
        path: 'sign-clock-in',
        loadChildren: () => import('./Pages/Rrhh/Clock-in/sign-clock-in/sign-clock-in.module').then(m => m.SignClockInPageModule)
      },
      {
        path: 'bottle-meter',
        loadChildren: () => import('./Pages/Shared/bottle-meter/bottle-meter.module').then(m => m.BottleMeterPageModule)
      },
      {
        path: 'widgets-store',
        loadChildren: () => import('./Pages/Widgets/widgets-store/widgets-store.module').then(m => m.WidgetsStorePageModule)
      },
      {
        path: 'communication-store',
        loadChildren: () => import('./Pages/Communication/communication-store/communication-store.module').then(m => m.CommunicationStorePageModule)
      },
      {
        path: 'communication/:id',
        loadChildren: () => import('./Pages/Communication/communication-detail/communication-detail.module').then(m => m.CommunicationDetailPageModule)
      },
      {
        path: 'communication-options',
        loadChildren: () => import('./Pages/Communication/communication-options/communication-options.module').then(m => m.CommunicationOptionsPageModule)
      },
      {
        path: 'breakdown-budget-store',
        loadChildren: () => import('./Pages/Communication/breakdown-budget-store/breakdown-budget-store.module').then(m => m.BreakdownBudgetStorePageModule)
      },
      {
        path: 'suggested-products-list',
        loadChildren: () => import('./Pages/Purchases/Products/suggested-products-list/suggested-products-list.module').then(m => m.SuggestedProductsListPageModule)
      },
      {
        path: 'assistant-chat',
        loadChildren: () => import('./Pages/Assistant/assistant-chat/assistant-chat.module').then(m => m.AssistantChatPageModule)
      },
      {
        path: 'widgets-filters',
        loadChildren: () => import('./Pages/Widgets/widgets-filters/widgets-filters.module').then(m => m.WidgetsFiltersPageModule)
      },
      {
        path: 'inventory-stock-options',
        loadChildren: () => import('./Pages/Warehouse/Inventory/inventory-stock-options/inventory-stock-options.module').then(m => m.InventoryStockOptionsPageModule)
      },
      {
        path: 'videos-viewer',
        loadChildren: () => import('./Pages/Shared/videos-viewer/videos-viewer.module').then(m => m.VideosViewerPageModule)
      },
      {
        path: 'event/:id',
        loadChildren: () => import('./Pages/Events/event-detail/event-detail.module').then(m => m.EventDetailPageModule)
      },
      {
        path: 'inventory-event/:id',
        loadChildren: () => import('./Pages/Events/inventory-event/inventory-event.module').then(m => m.InventoryEventPageModule)
      },
      {
        path: 'clock-in-detail-report',
        loadChildren: () => import('./Pages/Reports/Rrhh/Clock-in/clock-in-detail-report/clock-in-detail-report.module').then(m => m.ClockInDetailReportPageModule)
      },
      {
        path: 'share-clock-in-report',
        loadChildren: () => import('./Pages/Reports/Rrhh/Clock-in/share-clock-in-report/share-clock-in-report.module').then(m => m.ShareClockInReportPageModule)
      },
      {
        path: 'print-label-options',
        loadChildren: () => import('./Pages/Shared/print-label-options/print-label-options.module').then(m => m.PrintLabelOptionsPageModule)
      },
      {
        path: 'delivery-note-review/:id',
        loadChildren: () => import('./Pages/Documents-review/delivery-note-review/delivery-note-review.module').then(m => m.DeliveryNoteReviewPageModule)
      },
      {
        path: 'expense-review',
        loadChildren: () => import('./Pages/Documents-review/expense-review/expense-review.module').then(m => m.ExpenseReviewPageModule)
      },
      {
        path: 'payroll-review',
        loadChildren: () => import('./Pages/Documents-review/payroll-review/payroll-review.module').then(m => m.PayrollReviewPageModule)
      },
      {
        path: 'unclassified-review',
        loadChildren: () => import('./Pages/Documents-review/unclassified-review/unclassified-review.module').then(m => m.UnclassifiedReviewPageModule)
      }
    ]
  },
  {
    path: 'login',
    loadChildren: () => import('./Pages/Auth/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./Pages/Auth/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'forget-pass',
    loadChildren: () => import('./Pages/Auth/forget-pass/forget-pass.module').then(m => m.ForgetPassPageModule)
  },
  {
    path: 'visor',
    loadChildren: () => import('./Pages/Auth/visor/visor.module').then(m => m.VisorPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
